import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';


const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    // key: 'code',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Name',
    dataIndex: 'name',
    // key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Type',
    dataIndex: 'type',
    // key: 'type',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
]


const MyFooter = ({ save, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={save} type='primary'>SAVE</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};


const AddAccountModal = ({ accounts }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);

  
  const handleCancel = () => setIsModalOpen(false);
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const save = () => {
    EventEmitter.dispatch('budgetary_position_accounts', selectedAccounts);
    handleCancel();
  }

  useEffect(() => {
    EventEmitter.subscribe('add_account_modal', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('add_account_modal');
  },[]);

  const onSelectChange = (keys, newSelectedRowKeys) => {
    // console.log(newSelectedRowKeys)
    let data = newSelectedRowKeys.map(obj => ({_id: obj._id, code: obj.code, name: obj.name}));
    setSelectedAccounts(data);
  };
  // const rowSelection = {
  //   selectedRowKeys: selectedAccounts,
  //   onChange: onSelectChange,
  // };  


  return (
    <Modal title="Add: Accounts" width={700} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} save={save}/>}>
      <Table 
        sticky
        columns={columns}
        dataSource={accounts}
        scroll={{ y: 400,}}
        pagination={false}
        rowKey={'_id'}
        rowSelection={{type: 'checkbox', onChange:(key, rows)=>onSelectChange(key, rows)}}
      />
    </Modal>
  )
}

export default AddAccountModal;